import vNavbar from "./v-navbar.vue";
import vNavbarLogo from "./v-navbar-logo.vue";
import vNavbarNavigation from "./v-navbar-navigation.vue";
import vNavbarNavigationItem from "./v-navbar-navigation-item.vue";
import vNavbarMenu from "./v-navbar-menu.vue";
import vNavbarMenuItem from "./v-navbar-menu-item.vue";

export default Vue => {
  // Wrapper
  Vue.component("v-navbar", vNavbar);

  // Logo
  Vue.component("v-navbar-logo", vNavbarLogo);

  // Navigation
  Vue.component("v-navbar-navigation", vNavbarNavigation);
  Vue.component("v-navbar-navigation-item", vNavbarNavigationItem);

  // Menu
  Vue.component("v-navbar-menu", vNavbarMenu);
  Vue.component("v-navbar-menu-item", vNavbarMenuItem);
};
